var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Delete_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64356 1.62148C8.83807 1.62148 9 1.78298 9 1.98848V2.17848C9 2.37898 8.83807 2.54547 8.64356 2.54547H0.356927C0.16193 2.54547 0 2.37898 0 2.17848V1.98848C0 1.78298 0.16193 1.62148 0.356927 1.62148H1.81478C2.11092 1.62148 2.36865 1.41099 2.43527 1.11399L2.51162 0.772992C2.63027 0.308497 3.02075 0 3.46764 0H5.53236C5.97439 0 6.36925 0.308497 6.48352 0.748493L6.56522 1.11349C6.63135 1.41099 6.88907 1.62148 7.1857 1.62148H8.64356ZM7.90291 8.56701C8.05512 7.14852 8.3216 3.77855 8.3216 3.74455C8.33132 3.64156 8.29777 3.54406 8.23115 3.46556C8.15967 3.39206 8.06922 3.34856 7.96953 3.34856H1.03426C0.934089 3.34856 0.838779 3.39206 0.772645 3.46556C0.705539 3.54406 0.672472 3.64156 0.677335 3.74455C0.678229 3.7508 0.687791 3.86951 0.703776 4.06796C0.774792 4.94958 0.972585 7.40507 1.1004 8.56701C1.19084 9.423 1.75249 9.96099 2.56603 9.98049C3.19381 9.99499 3.84056 9.99999 4.5019 9.99999C5.12482 9.99999 5.75746 9.99499 6.4047 9.98049C7.24644 9.96599 7.8076 9.4375 7.90291 8.56701Z",
    fill: "#E71D36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.394f18147e1554c9730d595a7cfcc83e.svg";
export { ForwardRef as ReactComponent };